import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setTelemetryCustom, setTelemetryLabels, setTelemetryUser } from 'services/store/features/telemetry/actions';
import LandingPage from './LandingPage';
var mapStateToProps = function (state) { return ({
    project: state.project,
}); };
var mapDispatchToProps = function (dispatch) { return ({
    actions: bindActionCreators({ setTelemetryCustom: setTelemetryCustom, setTelemetryLabels: setTelemetryLabels, setTelemetryUser: setTelemetryUser }, dispatch),
}); };
export default connect(mapStateToProps, mapDispatchToProps)(LandingPage);
